var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',[_c('oil-cap',{attrs:{"title":'Арендованные автомобили'.toUpperCase(),"buttons":[
                {
                  route: 'vehicle-hire',
                  name: 'добавить автомобиль'
                }
      ]}}),_c('v-divider',{staticClass:"mt-2 mb-2"}),_c('oil-table',{attrs:{"items":_vm.vehicles,"keys":[
        {text:'название',value:'Name'},
        {text:'модель',value:'Model'},
        {text:'гос. номер',value:'ModelRegistrationNumber'},
        {text:'литраж',value:'Volume'},
        {text:'статус',value:'Status'},
        {text:'',value:'Id'} ]},scopedSlots:_vm._u([{key:"Id",fn:function(ref){
    var value = ref.value;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
    var on = ref.on;
    var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.rowClick(value)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" mdi-pen ")])],1)]}}],null,true)},[_c('span',[_vm._v("РЕДАКТИ́РОВАТЬ")])])]}},{key:"Status",fn:function(ref){
    var value = ref.value;
return [_c('v-chip',{attrs:{"color":_vm.status[value].color}},[_vm._v(" "+_vm._s(_vm.status[value].value)+" ")])]}}],null,false,1935472960)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }